import { getActiveRentalAdvancePayment } from "../../../data/loca/rentals";
import { send } from "../../../services/NotificationService";


export async function loader({ params }) {
    const payment = await getActiveRentalAdvancePayment(params.rentalId);
    var error = payment.message;

    if (payment.status === 200) {
        let link = `/acompte/${payment.message}/${params.rentalId}`

        window.location.href = link;
        return {  };
    }
    else {
        send("warning", error)

        return { error };

    }

}


export default function SwitchPayment() {
    return (<></>)

}
